"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rating = exports.toggle = exports.textArea = exports.select = exports.radioGroup = exports.inputField = exports.addressFormElement = exports.richTextEditor = exports.hiddenField = exports.element = exports.datepicker = exports.currencyField = exports.comboBox = exports.array = void 0;
const enums_1 = require("../structs/enums");
function array(arrayConfig) {
    var _a;
    return Object.assign({ controlName: (_a = arrayConfig.controlName) !== null && _a !== void 0 ? _a : arrayConfig.dataPath, elementType: enums_1.FluidFormElementType.ARRAY }, arrayConfig);
}
exports.array = array;
function comboBox(comboBoxConfig) {
    var _a, _b;
    return Object.assign({ controlName: (_a = comboBoxConfig.controlName) !== null && _a !== void 0 ? _a : comboBoxConfig.dataPath, elementType: enums_1.FluidFormElementType.COMBO_BOX, inlineField: (_b = comboBoxConfig.inlineField) !== null && _b !== void 0 ? _b : true }, comboBoxConfig);
}
exports.comboBox = comboBox;
function currencyField(currencyFieldConfig) {
    var _a, _b;
    return Object.assign({ controlName: (_a = currencyFieldConfig.controlName) !== null && _a !== void 0 ? _a : currencyFieldConfig.dataPath, elementType: enums_1.FluidFormElementType.CURRENCY, inlineField: (_b = currencyFieldConfig.inlineField) !== null && _b !== void 0 ? _b : true, type: enums_1.FluidInputType.CURRENCY }, currencyFieldConfig);
}
exports.currencyField = currencyField;
function datepicker(datepickerConfig) {
    var _a, _b;
    return Object.assign({ controlName: (_a = datepickerConfig.controlName) !== null && _a !== void 0 ? _a : datepickerConfig.dataPath, elementType: enums_1.FluidFormElementType.DATEPICKER, inlineField: (_b = datepickerConfig.inlineField) !== null && _b !== void 0 ? _b : true }, datepickerConfig);
}
exports.datepicker = datepicker;
function element(elementConfig) {
    return elementConfig;
}
exports.element = element;
function hiddenField(hiddenFieldConfig) {
    var _a, _b;
    return Object.assign({ controlName: (_a = hiddenFieldConfig.controlName) !== null && _a !== void 0 ? _a : hiddenFieldConfig.dataPath, elementType: enums_1.FluidFormElementType.HIDDEN, inlineField: (_b = hiddenFieldConfig.inlineField) !== null && _b !== void 0 ? _b : true }, hiddenFieldConfig);
}
exports.hiddenField = hiddenField;
function richTextEditor(richTextEditorConfig) {
    var _a, _b;
    return Object.assign({ controlName: (_a = richTextEditorConfig.controlName) !== null && _a !== void 0 ? _a : richTextEditorConfig.dataPath, elementType: enums_1.FluidFormElementType.RICH_TEXT_EDITOR, inlineField: (_b = richTextEditorConfig.inlineField) !== null && _b !== void 0 ? _b : true }, richTextEditorConfig);
}
exports.richTextEditor = richTextEditor;
function addressFormElement(addressFormElement) {
    var _a, _b;
    return Object.assign({ controlName: (_a = addressFormElement.controlName) !== null && _a !== void 0 ? _a : addressFormElement.dataPath, elementType: enums_1.FluidFormElementType.ADDRESS_FORM, inlineField: (_b = addressFormElement.inlineField) !== null && _b !== void 0 ? _b : true }, addressFormElement);
}
exports.addressFormElement = addressFormElement;
function inputField(inputFieldConfig) {
    var _a, _b;
    return Object.assign({ controlName: (_a = inputFieldConfig.controlName) !== null && _a !== void 0 ? _a : inputFieldConfig.dataPath, elementType: enums_1.FluidFormElementType.INPUT, inlineField: (_b = inputFieldConfig.inlineField) !== null && _b !== void 0 ? _b : true }, inputFieldConfig);
}
exports.inputField = inputField;
function radioGroup(radioGroupConfig) {
    var _a, _b;
    return Object.assign({ controlName: (_a = radioGroupConfig.controlName) !== null && _a !== void 0 ? _a : radioGroupConfig.dataPath, elementType: enums_1.FluidFormElementType.RADIO_GROUP, inlineField: (_b = radioGroupConfig.inlineField) !== null && _b !== void 0 ? _b : true }, radioGroupConfig);
}
exports.radioGroup = radioGroup;
function select(selectConfig) {
    var _a, _b;
    return Object.assign({ controlName: (_a = selectConfig.controlName) !== null && _a !== void 0 ? _a : selectConfig.dataPath, elementType: enums_1.FluidFormElementType.SELECT, inlineField: (_b = selectConfig.inlineField) !== null && _b !== void 0 ? _b : true }, selectConfig);
}
exports.select = select;
function textArea(textAreaConfig) {
    var _a, _b;
    return Object.assign({ controlName: (_a = textAreaConfig.controlName) !== null && _a !== void 0 ? _a : textAreaConfig.dataPath, elementType: enums_1.FluidFormElementType.TEXTAREA, inlineField: (_b = textAreaConfig.inlineField) !== null && _b !== void 0 ? _b : true }, textAreaConfig);
}
exports.textArea = textArea;
function toggle(toggleConfig) {
    var _a, _b;
    return Object.assign({ controlName: (_a = toggleConfig.controlName) !== null && _a !== void 0 ? _a : toggleConfig.dataPath, elementType: enums_1.FluidFormElementType.TOGGLE, inlineField: (_b = toggleConfig.inlineField) !== null && _b !== void 0 ? _b : true }, toggleConfig);
}
exports.toggle = toggle;
function rating(ratingConfig) {
    var _a, _b;
    return Object.assign({ controlName: (_a = ratingConfig.controlName) !== null && _a !== void 0 ? _a : ratingConfig.dataPath, elementType: enums_1.FluidFormElementType.RATING, inlineField: (_b = ratingConfig.inlineField) !== null && _b !== void 0 ? _b : true }, ratingConfig);
}
exports.rating = rating;
